import {Injectable} from '@angular/core';
import {BehaviorSubject} from 'rxjs';
import {Dienst} from '../models';

@Injectable({
  providedIn: 'root'
})
export class FormService {
  public submittedForm = new BehaviorSubject(null);

  public dienste = new BehaviorSubject('');
  public dienste$ = this.dienste.asObservable();

  public allowedDienste = new BehaviorSubject([]);
  public oldDienst;

  public shipmentInfo = new BehaviorSubject([]);

  public selbstabholer = new BehaviorSubject(false);
  public selbstAbh;


  constructor() {
    this.allowedDienste.subscribe((allowedDienste: Dienst[]) => {
      allowedDienste.forEach((oldDienst: Dienst) => {
        this.oldDienst = oldDienst
      })
    });
    this.selbstabholer.subscribe((selbstAbh: boolean) => {
      this.selbstAbh = selbstAbh;
    })
  }

  getSubmittedForm(form) {
    let formsValue = form;
    let dienstKorrektur = {};

    if (formsValue.dienste !== null) {
      dienstKorrektur =
        {
          diensttypId: formsValue.dienste.id,
          datumUhrzeit: formsValue.datumUhrzeit
        }
    } else if(this.selbstAbh) {
      dienstKorrektur =
        {
          diensttypId: 83,
          datumUhrzeit: formsValue.datumUhrzeit
        }
    }
    else {
      dienstKorrektur;
    }

    let reqBody: any = {
      sendungId: null,
      dienstKorrektur: dienstKorrektur,
      colli: formsValue.colli,
      paletten: formsValue.palette,
      gesamtgewicht: formsValue.gewicht
    };

    this.submittedForm.next(reqBody);
  }

  setDienste(dienste) {
    this.dienste.next(dienste);
  };
}
